export interface CategoriaJSON {
    cat_id: string | null;
    cat_nombre: string;
    cat_anio_desde: number;
    cat_anio_hasta: number;
    cat_duracion_periodo: number;
    cat_cant_periodos: number;
    cat_cant_periodos_extra: number;
    cat_duracion_periodo_extra: number;
    cat_activa: boolean;
    cat_temid: string;
    cat_pertenece_tira_inferiores: boolean;
}

export class Categoria {
    protected constructor(
    private catId: string | null,
    private catNombre: string,
    private catAnioDesde: number,
    private catAnioHasta: number,
    private catDuracionPeriodo: number,
    private catCantPeriodos: number,
    private catCantPeriodosExtra: number,
    private catDuracionPeriodoExtra: number,
    private catActiva: boolean,
    private catTemid: string,
    private catPerteneceTiraInferiores: boolean) {}

    static createFrom( catId: string | null,
    catNombre: string,
    catAnioDesde: number,
    catAnioHasta: number,
    catDuracionPeriodo: number,
    catCantPeriodos: number,
    catCantPeriodosExtra: number,
    catDuracionPeriodoExtra: number,
    catActiva: boolean,
    catTemid: string,
    catPerteneceTiraInferiores: boolean) {
        return new this( catId,
        catNombre,
        catAnioDesde,
        catAnioHasta,
        catDuracionPeriodo,
        catCantPeriodos,
        catCantPeriodosExtra,
        catDuracionPeriodoExtra,
        catActiva,
        catTemid,
        catPerteneceTiraInferiores)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.catId === anId
    }

    isIdentifiedAs(aEntity: Categoria) {
        if(this.catId){
            return aEntity.isIdentifiedBy(this.catId)
        } else {
            return false
        }

    }

    static fromJSON(entity: CategoriaJSON) {
        return Categoria.createFrom( entity.cat_id,
        entity.cat_nombre,
        entity.cat_anio_desde,
        entity.cat_anio_hasta,
        entity.cat_duracion_periodo,
        entity.cat_cant_periodos,
        entity.cat_cant_periodos_extra,
        entity.cat_duracion_periodo_extra,
        entity.cat_activa,
        entity.cat_temid,
        entity.cat_pertenece_tira_inferiores)
    }

    toJSON(): CategoriaJSON {
        return {
            cat_id: this.getId(),
            cat_nombre: this.getNombre(),
            cat_anio_desde: this.getAnioDesde(),
            cat_anio_hasta: this.getAnioHasta(),
            cat_duracion_periodo: this.getDuracionPeriodo(),
            cat_cant_periodos: this.getCantPeriodos(),
            cat_cant_periodos_extra: this.getCantPeriodosExtra(),
            cat_duracion_periodo_extra: this.getDuracionPeriodoExtra(),
            cat_activa: this.getActiva(),
            cat_temid: this.getTemid(),
            cat_pertenece_tira_inferiores: this.getPerteneceTiraInferiores()
        }

    }

    toJSONnew(): CategoriaJSON {
      return {
        cat_id: 'new',
        cat_nombre: this.getNombre(),
        cat_anio_desde: this.getAnioDesde(),
        cat_anio_hasta: this.getAnioHasta(),
        cat_duracion_periodo: this.getDuracionPeriodo(),
        cat_cant_periodos: this.getCantPeriodos(),
        cat_cant_periodos_extra: this.getCantPeriodosExtra(),
        cat_duracion_periodo_extra: this.getDuracionPeriodoExtra(),
        cat_activa: this.getActiva(),
        cat_temid: this.getTemid(),
        cat_pertenece_tira_inferiores: this.getPerteneceTiraInferiores(),
      };
    }

    getId(): string | null { return this.catId; }

    getNombre(): string { return this.catNombre; }

    getAnioDesde(): number { return this.catAnioDesde; }

    getAnioHasta(): number { return this.catAnioHasta; }

    getDuracionPeriodo(): number { return this.catDuracionPeriodo; }

    getCantPeriodos(): number { return this.catCantPeriodos; }

    getCantPeriodosExtra(): number { return this.catCantPeriodosExtra; }

    getDuracionPeriodoExtra(): number { return this.catDuracionPeriodoExtra; }

    getActiva(): boolean { return this.catActiva; }

    getTemid(): string { return this.catTemid; }

    getPerteneceTiraInferiores(): boolean { return this.catPerteneceTiraInferiores; }

    setId(value: string | null):void { this.catId = value; }

    setNombre(value: string):void { this.catNombre = value; }

    setAnioDesde(value: number):void { this.catAnioDesde = value; }

    setAnioHasta(value: number):void { this.catAnioHasta = value; }

    setDuracionPeriodo(value: number):void { this.catDuracionPeriodo = value; }

    setCantPeriodos(value: number):void { this.catCantPeriodos = value; }

    setCantPeriodosExtra(value: number):void { this.catCantPeriodosExtra = value; }

    setDuracionPeriodoExtra(value: number):void { this.catDuracionPeriodoExtra = value; }

    setActiva(value: boolean):void { this.catActiva = value; }

    setTemid(value: string):void { this.catTemid = value; }

    setPerteneceTiraInferiores(value: boolean):void { this.catPerteneceTiraInferiores = value; }

}

